import { createAsyncThunk } from '@reduxjs/toolkit';
import { AssessmentQuestionApi } from '../../services/end-points';
import { resolveApiCall } from '../../services/api-handlers/api-resolver';
import { makeFormErrorsFromResponse } from '../../components/react-hook-form/utils/make-form-errors';
import { ThunkConfig } from '../configure-store';
import { AssessmentQuestion } from '../../types/assessment-question';

export const listAssessmentQuestion = createAsyncThunk<AssessmentQuestion[], void, ThunkConfig>(
    'assessment-question/list',
    async (_, thunkApi) => {
        const { getState } = thunkApi;
        const { assessmentQuestion } = getState();

        return resolveApiCall(
            thunkApi,
            assessmentQuestion,
            async () => (await AssessmentQuestionApi.list()).data,
            async (err) => {
                const { response } = err;
                return makeFormErrorsFromResponse(response.data);
            },
        );
    },
);

export const updateAssessmentQuestion = createAsyncThunk<
    AssessmentQuestion,
    { id: AssessmentQuestion['id']; data: { name: string } },
    ThunkConfig
>('assessment-question/update', async (payload, thunkApi) => {
    const { getState } = thunkApi;
    const { assessmentQuestion } = getState();
    const { id, data } = payload;
    return resolveApiCall(
        thunkApi,
        assessmentQuestion,
        async () => await AssessmentQuestionApi.update(id, data),
        async (err) => {
            const { response } = err;
            return makeFormErrorsFromResponse(response.data);
        },
    );
});
